// Icons — original line icons in lucide style
import React from 'react';

const Icon = ({ name, size = 16, stroke = 1.6, ...rest }) => {
  const paths = {
    pyramid: (
      <g>
        <path d="M12 3 L21 19 L3 19 Z" />
        <path d="M12 3 L12 19" opacity="0.4" />
        <path d="M3 19 L12 11 L21 19" opacity="0.4" />
      </g>
    ),
    today:    <g><circle cx="12" cy="12" r="4" /><path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4l1.4-1.4M17 7l1.4-1.4" /></g>,
    layers:   <g><path d="M12 3 3 8l9 5 9-5z" /><path d="M3 12l9 5 9-5" /><path d="M3 16l9 5 9-5" /></g>,
    calendar: <g><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 10h18M8 3v4M16 3v4" /></g>,
    brain:    <g><path d="M9 4a3 3 0 0 0-3 3v1a3 3 0 0 0-2 2.8c0 1.5 1 2.7 2.3 3 0 1.6 1.3 3 3 3a3 3 0 0 0 2.7-1.6"/><path d="M15 4a3 3 0 0 1 3 3v1a3 3 0 0 1 2 2.8c0 1.5-1 2.7-2.3 3 0 1.6-1.3 3-3 3a3 3 0 0 1-2.7-1.6"/><path d="M12 5v14"/></g>,
    sparkles: <g><path d="M12 3l1.6 4.4L18 9l-4.4 1.6L12 15l-1.6-4.4L6 9l4.4-1.6z" /><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z"/></g>,
    book:     <g><path d="M4 4h12a4 4 0 0 1 4 4v12H8a4 4 0 0 1-4-4z" /><path d="M4 16a4 4 0 0 1 4-4h12" /></g>,
    sliders:  <g><path d="M4 6h10M18 6h2M4 12h2M10 12h10M4 18h14M18 18h2"/><circle cx="16" cy="6" r="2"/><circle cx="8" cy="12" r="2"/><circle cx="16" cy="18" r="2"/></g>,
    grid:     <g><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></g>,
    inbox:    <g><path d="M3 13v5a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5" /><path d="M3 13l3-9h12l3 9" /><path d="M3 13h5l1 2h6l1-2h5"/></g>,
    plus:     <g><path d="M12 5v14M5 12h14"/></g>,
    minus:    <g><path d="M5 12h14"/></g>,
    check:    <g><path d="M5 12l5 5 9-11"/></g>,
    chev_right: <g><path d="M9 6l6 6-6 6"/></g>,
    chev_left:  <g><path d="M15 6l-6 6 6 6"/></g>,
    chev_down:  <g><path d="M6 9l6 6 6-6"/></g>,
    arrow_right:<g><path d="M5 12h14M13 6l6 6-6 6"/></g>,
    search:   <g><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></g>,
    mic:      <g><rect x="9" y="3" width="6" height="12" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3"/></g>,
    moon:     <g><path d="M20 14a8 8 0 0 1-9-12 8 8 0 1 0 9 12z"/></g>,
    sun:      <g><circle cx="12" cy="12" r="4"/><path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4l1.4-1.4M17 7l1.4-1.4"/></g>,
    flag:     <g><path d="M5 21V4M5 4h11l-2 4 2 4H5"/></g>,
    bell:     <g><path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6"/><path d="M10 19a2 2 0 0 0 4 0"/></g>,
    more:     <g><circle cx="6" cy="12" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="18" cy="12" r="1.5"/></g>,
    menu:     <g><path d="M4 7h16M4 12h16M4 17h16"/></g>,
    target:   <g><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.5"/></g>,
    flame:    <g><path d="M12 3c1 4 5 5 5 10a5 5 0 0 1-10 0c0-2 1-3 2-4 0 2 1 3 2 3 0-3-1-5 1-9z"/></g>,
    leaf:     <g><path d="M5 19c0-9 6-15 15-15 0 9-6 15-15 15z"/><path d="M5 19l8-8"/></g>,
    dumbbell: <g><path d="M3 9v6M7 7v10M17 7v10M21 9v6M7 12h10"/></g>,
    coffee:   <g><path d="M4 8h13v6a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"/><path d="M17 10h2a2 2 0 0 1 0 4h-2"/><path d="M7 4c0 1 1 1 1 2M11 4c0 1 1 1 1 2"/></g>,
    heart:    <g><path d="M12 20s-7-4.5-9-10c-1-3 2-6 5-6 2 0 3 1 4 3 1-2 2-3 4-3 3 0 6 3 5 6-2 5.5-9 10-9 10z"/></g>,
    car:      <g><path d="M5 17h14l-2-7H7z"/><circle cx="8" cy="17" r="2"/><circle cx="16" cy="17" r="2"/></g>,
    rocket:   <g><path d="M5 19c0-2 1-3 3-3l5-5 5-5c2 0 3 1 3 3l-5 5-5 5c0 2-1 3-3 3z"/><circle cx="15" cy="9" r="1.5"/></g>,
    settings: <g><circle cx="12" cy="12" r="3"/><path d="M19 12c0 1-1 2-1 3l1 2-2 2-2-1c-1 1-2 1-3 1l-1 2h-2l-1-2c-1 0-2 0-3-1l-2 1-2-2 1-2c0-1-1-2-1-3s1-2 1-3l-1-2 2-2 2 1c1-1 2-1 3-1l1-2h2l1 2c1 0 2 0 3 1l2-1 2 2-1 2c0 1 1 2 1 3z"/></g>,
    github:   <g><path d="M12 3a9 9 0 0 0-3 17.5c.5 0 .5-.2.5-.5v-2c-2.5.5-3-1-3-1-.5-1-1-1.5-1-1.5-1-.5 0-.5 0-.5 1 0 1.5 1 1.5 1 1 2 3 1.5 4 1 0-.5.5-1 1-1.5-2 0-4-1-4-4 0-1 .5-2 1-2.5 0-.5-.5-1.5 0-3 0 0 1 0 2 1.5 1-.3 2-.4 3-.4s2 .1 3 .4c1-1.5 2-1.5 2-1.5.5 1.5 0 2.5 0 3 .5.5 1 1.5 1 2.5 0 3-2 4-4 4 .5.5 1 1.5 1 3v2.5c0 .3 0 .5.5.5A9 9 0 0 0 12 3z"/></g>,
    tag:      <g><path d="M3 11V4h7l11 11-7 7z"/><circle cx="7" cy="8" r="1.2"/></g>,
    home:     <g><path d="M4 11l8-7 8 7v9a1 1 0 0 1-1 1h-4v-6h-6v6H5a1 1 0 0 1-1-1z"/></g>,
    refresh:  <g><path d="M4 12a8 8 0 0 1 14-5l2 2"/><path d="M20 4v4h-4"/><path d="M20 12a8 8 0 0 1-14 5l-2-2"/><path d="M4 20v-4h4"/></g>,
    play:     <g><path d="M7 4l13 8-13 8z"/></g>,
    edit:     <g><path d="M4 20h4l11-11-4-4L4 16z"/><path d="M14 5l4 4"/></g>,
    trash:    <g><path d="M5 7h14M9 7V4h6v3M7 7l1 13h8l1-13"/></g>,
    x:        <g><path d="M6 6l12 12M18 6l-12 12"/></g>,
    drag:     <g><circle cx="9" cy="6" r="1.2"/><circle cx="9" cy="12" r="1.2"/><circle cx="9" cy="18" r="1.2"/><circle cx="15" cy="6" r="1.2"/><circle cx="15" cy="12" r="1.2"/><circle cx="15" cy="18" r="1.2"/></g>,
    folder:   <g><path d="M3 6a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></g>,
    clock:    <g><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></g>,
    chart:    <g><path d="M4 20V4M4 20h16"/><path d="M8 16v-5M12 16V8M16 16v-9"/></g>,
    fire_solid: <g><path d="M12 2c1 4 6 6 6 11a6 6 0 0 1-12 0c0-3 1-4 3-5 0 2 1 3 2 3 0-3-1-5 1-9z" fill="currentColor" stroke="none"/></g>,
  };
  const p = paths[name];
  if (!p) return null;
  return (
    <svg className="icon" width={size} height={size} viewBox="0 0 24 24" fill="none"
         stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" {...rest}>
      {p}
    </svg>
  );
};

const Pyramid = ({ size = 22 }) => (
  <svg className="pyramid" width={size} height={size} viewBox="0 0 32 32" fill="none">
    <path d="M16 3 L29 27 L3 27 Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M16 3 L16 27" stroke="currentColor" strokeWidth="1.4" opacity="0.35" />
    <path d="M3 27 L16 14 L29 27" stroke="currentColor" strokeWidth="1.4" opacity="0.35" strokeLinejoin="round" />
    <circle cx="16" cy="14" r="1.6" fill="currentColor" />
  </svg>
);

export { Icon, Pyramid };
